<template>
  <section class="container">
    <div v-if="interactable" class="hidden"></div>
    <BuilderComponent v-if="props.rows" :rows="props.rows" v-bind="$attrs" />
  </section>
</template>
<script lang="ts" setup>
import BuilderComponent, { Row } from '@/components/Builder/BuilderComponent.vue'
import { computed } from 'vue'

type Props = {
  width?: string
  rows?: Row[]
}
const props = defineProps<Props>()

const interactable = computed(
  () => props.rows?.some((row) => row.cols?.some((c) => c.type === 'button') ?? false) ?? false
)
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/font-mixins';
section.container {
  border-radius: 8px;
  overflow: hidden;
  padding: 12px 1em;
  width: v-bind('props.width ?? "200px"');
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;

  .hidden {
    position: absolute;
    height: 20px;
    width: v-bind('props.width ?? "200px"');
    bottom: -20px;
    margin-left: -12px;
  }
}
section.header {
  display: flex;
  flex-direction: column;
  h1,
  h2,
  h3 {
    all: unset;
    display: flex;
    flex-direction: row;
    width: 100%;
  }
  h1 {
    @include font-mixins.desktop-bold-paragraph;
    color: #1a1a1a;
  }
  h2 {
    @include font-mixins.desktop-bold-tiny;
    color: #767676;
    &.main {
      margin-bottom: 6px;
    }
  }
  h3 {
    @include font-mixins.desktop-bold-tiny;
    color: #767676;
  }

  .icons img {
    width: 30px;
    height: 25px;
    padding-right: 10px;
  }

  .icon {
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }
}
</style>
